// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".incriment[data-v-469165f6]{width:120px;border-radius:10px;border:1px solid #f7f7f7;background:#fff;padding:10px 15px;display:flex;align-items:center;justify-content:space-between;margin-right:30px;cursor:pointer}.decrement:hover svg path[data-v-469165f6],.increment:hover svg path[data-v-469165f6]{fill:#fec55e;transition:.3s}@media(max-width:767px){.incriment[data-v-469165f6]{margin-right:10px}}", ""]);
// Exports
module.exports = exports;
